import React from 'react'
import { Card } from 'antd'
import "../../../../src/styles/StoreViewMid.css"
import NpsPaddedArcs from '../../../components/chart-bars/NpsPaddedArcs'
import NpsOverallScore from '../../../components/chart-bars/NpsOverallScore'

export default function StoreViewMid({data, tableData}) {
  return (
    <div  className='dashUpperstore_container'>
      <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }} className='dashstore_upper_card_left'>
        <p>Overall NPS Score</p>
        <NpsPaddedArcs data={data} />
      </Card>
      <Card style={{  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }} className='dashstore_upper_card_right'>
        <NpsOverallScore data={data} tableData={tableData}/>
      </Card>
    </div>
  )
}